"use client"

import { motion } from "framer-motion"
import { useEffect, useState } from "react"

const paths = [
  "M 62.558 182.445 l -60.058 25 l 0 39.5 l 516 0 l 0 -242 l -19.018 14 l -28.528 36.5 l -32.532 13 l -29.028 14.5 l -57.055 0 l -29.028 33 l -23.022 -16.5 l -23.523 28.5 l -27.026 9.5 l -25.025 32 l -38.537 0 l -17.017 9 l -26.025 -9 l -52.05 19 l -28.528 -6 Z",
  "M 54.5 194.152 l -52 13 l 0 39.5 l 516 0 l 0 -242 l -31 20.5 l -19.5 44 l -54 17.5 l -15 23 l -46.661 -27 l -26.839 51 l -25 -6 l -20 14 l -35 -14 l -15 21 l -19.5 16 l -11 16 l -60.5 7.5 l -52 -10 l -33 16 Z",
  "M 24.5 210.637 l -22 -7 l 0 39.5 l 516 0 l 0 -242 l -23 45 l -37 20 l -22.5 24.5 l -38 6 l -29 9.5 l -43.5 -15.5 l -24.5 15.5 l -20.5 29.5 l -34 11 l -15 24.5 l -20.5 -10 l -36 -10.5 l -48.5 13.5 l -50.5 29 l -51.5 17.5 Z",
]

const Earn = () => {
  const [pathIndex, setPathIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setPathIndex((prev) => (prev + 1) % paths.length)
    }, 6000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="-inset-x-2 -bottom-2 absolute h-full" aria-hidden="true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 521 250"
        className="block size-full"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <motion.path
          initial={{ d: paths[0] }}
          fill="#000"
          fillOpacity=".1"
          stroke="#fff"
          strokeWidth="5"
          animate={{ d: paths[pathIndex] }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
        />
      </svg>
    </div>
  )
}

export default Earn
